import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { checkAuth, logout } from './lib/api';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const { authenticated } = await checkAuth();
        setIsAuthenticated(authenticated);
      } catch {
        setIsAuthenticated(false);
      }
    };
    verify();
  }, []);

  const handleLogout = async () => {
    await logout();
    setIsAuthenticated(false);
  };

  if (isAuthenticated === null) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50">Lade...</div>;
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={isAuthenticated ? (
          <Dashboard onLogout={handleLogout} />
        ) : (
          <Login onLogin={setIsAuthenticated} />
        )} />
        {/* Note: DownloadPage is no longer needed for supported types as they open directly via URL */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
};

export default App;